
const SelectField = ({ 
    id, 
    label, 
    
    value, 
    onChange, 
    disabled = false, 
    required = false ,
    options = [],
}) => {
  return (
    <div className="flex flex-col">
      <label htmlFor={id}>{label}:</label>
        <select
            disabled={disabled}
            className="border-[2px] px-4 py-2"
            id={id}
            name={id}
            value={value}
            onChange={onChange}
            required={required}
        >
              <option value="" disabled selected>Select an option</option>

            {options.map((option, index) => (
                
                <option key={index} value={option}>
                    {option}
                </option>
            ))}
           
        </select>
    </div>
  );
}

export default SelectField;